module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(_vm.deleteModal === true) ? _c('demande-modal', {
    attrs: {
      "title": "Annuler une demande"
    },
    on: {
      "close": _vm.doCloseAnyModals
    }
  }, [_c('demande-delete', {
    attrs: {
      "slot": "body",
      "demande": _vm.demande
    },
    on: {
      "close": _vm.doCloseAnyModals
    },
    slot: "body"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.updateModal === true) ? _c('demande-modal', {
    attrs: {
      "title": "Modifier une demande"
    },
    on: {
      "close": _vm.doCloseAnyModals
    }
  }, [_c('demande-form', {
    attrs: {
      "slot": "body",
      "update-demande": _vm.demande
    },
    on: {
      "close": _vm.doCloseAnyModals
    },
    slot: "body"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.getErrorCancellation) ? _c('demande-modal', {
    attrs: {
      "title": _vm.getErrorTitle
    },
    on: {
      "close": _vm.doCloseAnyModals
    }
  }, [_c('error-modal', {
    attrs: {
      "slot": "body",
      "demande": _vm.demande
    },
    on: {
      "close": _vm.doCloseAnyModals
    },
    slot: "body"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.createModal === true) ? _c('demande-modal', {
    attrs: {
      "title": "Créer une nouvelle demande"
    },
    on: {
      "close": _vm.doCloseAnyModals
    }
  }, [_c('demande-form', {
    attrs: {
      "slot": "body"
    },
    on: {
      "close": _vm.doCloseAnyModals
    },
    slot: "body"
  })], 1) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "content-toolbar"
  }, [_c('div', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.clickCreate()
      }
    }
  }, [_vm._v("Créer une nouvelle demande")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.exportDemandes()
      }
    }
  }, [_vm._v("Exporter toutes les demandes")])]), _vm._v(" "), _c('demandes-list', {
    on: {
      "delete": _vm.clickDelete,
      "edit": _vm.clickEdit
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-10bc3696!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/demande/Demande.vue
// module id = 2082
// module chunks = 2